/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OWEventTypeResponse,
    OWEventTypeResponseFromJSON,
    OWEventTypeResponseFromJSONTyped,
    OWEventTypeResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20021
 */
export interface InlineResponse20021 {
    /**
     * 
     * @type {Array<OWEventTypeResponse>}
     * @memberof InlineResponse20021
     */
    eventTypes: Array<OWEventTypeResponse>;
}

export function InlineResponse20021FromJSON(json: any): InlineResponse20021 {
    return InlineResponse20021FromJSONTyped(json, false);
}

export function InlineResponse20021FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20021 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventTypes': ((json['eventTypes'] as Array<any>).map(OWEventTypeResponseFromJSON)),
    };
}

export function InlineResponse20021ToJSON(value?: InlineResponse20021 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventTypes': ((value.eventTypes as Array<any>).map(OWEventTypeResponseToJSON)),
    };
}


